import React from 'react';
import { Route } from 'react-router-dom';

const CustomFormApplicationRoute = ({ children, path }) => {
  return <Route path={path}>{children}</Route>;
};

export default CustomFormApplicationRoute;
